// src/pages/WorkerSignup.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import bynLogo from "./byn-logo.jpeg";

const API_WRK = process.env.REACT_APP_API_WRK;

const WorkerSignup = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!email || !password || !confirmPassword) {
      setMessage("All fields are required.");
      return;
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^+=~])[A-Za-z\d@$!%*?&#^+=~]{8,}$/;

    if (!passwordRegex.test(password)) {
      setMessage(
        "Password must be 8+ characters with uppercase, number & special character."
      );
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      const res = await axios.post(`${API_WRK}/signup`, {
        email,
        password,
      });

      if (res.status === 201) {
        localStorage.setItem("workerId", res.data._id);
        localStorage.setItem("userEmail", email);
        navigate("/legal-name");
      }
    } catch (err) {
      setMessage(err.response?.data?.message || "Signup failed.");
    }
  };

  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-md mx-auto space-y-6">

        {/* 🔥 BIG BYN LOGO (MATCHES LOGIN) */}
        <div className="flex justify-center">
          <img
            src={bynLogo}
            alt="Book Your Need"
            className="w-44 h-44 object-contain"
          />
        </div>

        <form onSubmit={handleSignup} className="space-y-4">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <input
            type="password"
            placeholder="Confirm password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <button
            type="submit"
            className="w-full py-3 rounded-full font-semibold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:opacity-90 active:scale-95 transition"
          >
            Sign Up
          </button>
        </form>

        <p className="text-sm text-gray-500 text-center">
          Already have an account?{" "}
          <button
            onClick={() => navigate("/worker-login")}
            className="text-indigo-600 font-semibold hover:underline"
          >
            Log in
          </button>
        </p>

        {message && (
          <p className="text-sm text-red-500 text-center">{message}</p>
        )}
      </div>
    </div>
  );
};

export default WorkerSignup;
